import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material';

import { checkIfIsArray } from '@e-socna/utils';
import { EMPTY_OBJECT } from '@e-socna/empty';

import { N_A } from '../constants/labels.constant';
import { formatDate } from '../utils/format-date.util';

import { PageViewer } from './PageViewer';

interface Props {
  readonly interventionDate?: string | null;
  readonly modalities?: string | null;
  readonly note?: string | null;
  readonly paymentMethod: string;
  readonly paymentTerms: string;
  readonly sx?: SxProps<Theme>;
  readonly validityPeriod: string;
}

export const QuotationHeader = ({
  interventionDate = null,
  modalities = null,
  note = null,
  paymentMethod,
  paymentTerms,
  sx = EMPTY_OBJECT,
  validityPeriod,
}: Readonly<Props>) => (
  <Stack
    spacing={2}
    sx={[{ width: '100%' }, ...(checkIfIsArray(sx) ? sx : [sx])]}
  >
    <Paper sx={{ p: 2 }}>
      <Box sx={{ position: 'relative' }}>
        <Typography gutterBottom variant="body1">
          Moyen de Paiement : {paymentMethod}
        </Typography>
        <Typography gutterBottom variant="body1">
          Conditions de Réglement : {paymentTerms}
        </Typography>
        <Typography gutterBottom variant="body1">
          Durée de Validité du Devis : {validityPeriod}
        </Typography>
        <Typography gutterBottom variant="body1">
          Date d&apos;Intervention :{' '}
          {!interventionDate ? N_A : formatDate(interventionDate)}
        </Typography>
      </Box>
    </Paper>
    <Paper sx={{ p: 2 }}>
      <Box sx={{ position: 'relative' }}>
        <Typography gutterBottom variant="overline">
          Modalités
        </Typography>
        {modalities ? (
          <PageViewer html={modalities} />
        ) : (
          <Typography gutterBottom variant="body1">
            Non renseignées
          </Typography>
        )}
      </Box>
    </Paper>
    <Paper sx={{ p: 2 }}>
      <Box sx={{ position: 'relative' }}>
        <Typography gutterBottom variant="overline">
          Nota
        </Typography>
        {note ? (
          <PageViewer html={note} />
        ) : (
          <Typography gutterBottom variant="body1">
            Non renseigné
          </Typography>
        )}
      </Box>
    </Paper>
  </Stack>
);
